import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let WashingPageSection: React.FC<IWorksheetComponent> = () => (
  <PageSection heading="Washing">
    <WorksheetAssociatedTestSection
      testType="Wash"
      associatedTestModel={{
        measured: true,
      }}
      name="Washing.AssociatedWashTest"
      indented={false}
    />
  </PageSection>
);

WashingPageSection = withInjectedProps(WashingPageSection);

export { WashingPageSection };
export default WashingPageSection;
